/**
 * A customized Radium HOC which adds uses a custom plug-in to apply all vendor prefixes instead of trying to dynamically determine appropriate prefixes
 * We use this because the standard Radium prefixer was failing to apply prefixes on the 'appearance' property 
 */
import Radium from 'radium';
import prefixAll from 'inline-style-prefixer/static';

function addAllVendorPrefixes({ style }) {
    return {
        style: prefixAll(style)
    };
}

export default function(component) {
    return Radium({
        plugins: [
            Radium.Plugins.mergeStyleArray,
            Radium.Plugins.checkProps,
            Radium.Plugins.resolveMediaQueries,
            Radium.Plugins.resolveInteractionStyles,
            Radium.Plugins.keyframes,
            Radium.Plugins.visited,
            Radium.Plugins.removeNestedStyles,
            addAllVendorPrefixes,
            Radium.Plugins.checkProps,
        ],
    })(component);
}


// WEBPACK FOOTER //
// ./src/components/PrefixerRadium.js